import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import CpOnbordingSteps from "../CpOnbordingSteps/index";
import ViewAllCp from "../ViewAllCp";
import Heading from "../../../components/Heading";
import { useLocation } from "react-router";
import AppFooter from "../../../components/AppFooter";
import { Footer } from "antd/lib/layout/layout";
import AppHeader from "../../../components/AppHeader";
import Navbar from "../../../components/Navbar";
import ViewDetails from "../CpOnbordingSteps/ViewDetails";
function CpOnbordingTabs() {
  const [key, setKey] = useState("1");
  const history = useLocation();
  const [apiData, setApiData] = useState(null);
  let userData = JSON.parse(localStorage.getItem("userinfo"));
  const onChange = (key, res) => {
    if (apiData) {
      setKey(key);
    }
  };

  const responseFromChild = (data) => {
    setApiData(data);
  };
  return (
    <>
      {/* <AppHeader showLogo={true} /> */}
      <Navbar />
      <div className="p-2" style={{ minHeight: "90vh" }}>
        {/* <Heading title={"CP Onboarding"} navigateTo={"/onboarding-settings"} /> */}
        <div className="rate-card-tab-container">
          {userData?.type == "HUB" ? (
            <Tabs
              activeKey={key}
              items={[
                // {
                //   label: "CP Onboarding",
                //   key: "1",
                //   children: (
                //     <CpOnbordingSteps
                //       onChange={onChange}
                //       responseFromChild={responseFromChild}
                //     />
                //   ),
                // },
                // {
                //   label: "View Details",
                //   key: "2",
                //   children: <ViewDetails key={key} apiData={apiData} />,
                // },
                {
                  label: "View All CP",
                  key: "1",
                  children: <ViewAllCp />,
                },
              ]}
              onChange={onChange}
            />
          ) : (
            <Tabs
              activeKey={key}
              items={[
                {
                  label: "CP Onboarding",
                  key: "1",
                  children: (
                    <CpOnbordingSteps
                      onChange={onChange}
                      responseFromChild={responseFromChild}
                    />
                  ),
                },
                {
                  label: "View Details",
                  key: "2",
                  children: <ViewDetails key={key} apiData={apiData} />,
                },
              ]}
              onChange={onChange}
            />
          )}
        </div>
      </div>
      <Footer>
        <AppFooter />
      </Footer>
    </>
  );
}

export default CpOnbordingTabs;
